import axios from 'axios';

class I18NextHttpBackend {
  constructor(options = {}) {
    this.options = {
      loadPath: '/api/devtools/translations/by_language/?language_code={{lng}}',
      ...options
    };
  }

  read(language, namespace, callback) {
    const loadPath = this.options.loadPath.replace('{{lng}}', language);

    axios.get(loadPath)
      .then(response => {
        callback(null, response.data);
      })
      .catch(error => {
        console.error('Error loading translations:', error);
        callback(error, null);
      });
  }

  static type = 'backend';
}

export default I18NextHttpBackend;